export * as Person from 'types/ShoppingCart/Person';

export type Type = {
	firstName: string;
	lastName: string;
};

export function create(): Type {
	return {
		firstName: '',
		lastName: '',
	};
}

export function getName(obj: Type): string {
	return obj.firstName + ' ' + obj.lastName;
}
